export const LOCAL_STORAGE_KEY = 'tripWizardData';
export const S3_PATH_POST_LOCATION_LARGE = "public/post_location_images/large/";

// Default image paths
export const DEFAULT_POST_IMAGE = "/images/default_post.png";
export const DEFAULT_COVER_IMAGE = "/images/default_cover.png";
export const DEFAULT_PROFILE_IMAGE = "/images/default_profile.png";

// UI Constants
// Maximum number of photo carousel dots to display before showing text indicator
export const MAX_DOTS_DISPLAY = 20;

